import { CommonsEnvironment } from '@infodata-group/inf-commons';

export const environment: CommonsEnvironment = {
  production: true,
  env: 'preprod',

  api: {
    apiEndPoint: 'api/',
  },
  app: {
    appName: 'Portail',
    appVersion: '1.0.2',
    appVersionDate: '31/08/2023',
    defaultRoute: '',
    lang: ['fr'],
    cache: 0,
    appId: 'a5e8c8c6-d3a5-4230-9fdb-64213d2122e7',
  },
  auth: {
    loginUrl: 'api/auth/auth-default',
    logoutUrl: 'api/auth/logout',
    initApi: null,
    azure: {
      tenant: 'o365.infodata.lu',
      client: '1ab0c7d0-9cba-4569-ab50-cea719fc647c',
      redirectUri: 'https://preprod-portail.integrix.lu/oauth2',
      api: 'auth/auth-azure',
    },
  },
  login: {
    loginRoute: '/login',
    redirectAfterLogin: true,
    redirection: '/',
    defaultConnection: true,
  },
  portal: {
    api: 'auth-portal',
    userAppsApi: 'auth/portail-apps',
    loadPortalApps: true,
    portalUri: '',
    imagesUri: 'https://portail.integrix.lu/notifications-email/visu/',
  },
  ui: {
    appLogoPath: 'https://assets.integrix.lu/img/logos/integrix-portail.png',
    companyLogoPath: 'https://assets.integrix.lu/img/logos/infodata.svg',
    lockerBackgroundPath:
      'https://assets.integrix.lu/img/backgrounds/2025.webp',
  },
};
